import { yandexMetricService } from './YandexMetricService';
import { myTrackerService } from './MyTrackerService';
import { Params } from "OK/metrics/Service";
import { parseJsonConf } from "OK/utils/parseJsonConf";

enum Events {
    PAGE_INIT = 'visit::init',
    LOGIN = 'visit::login',
    REJECT_IMITATION = 'visit::15s',
    GOOD_VISIT_IMITATION = 'visit::60s',
}

const DEFAULT_REJECT_DURATION = 15_000;
const DEFAULT_VISIT_DURATION = 60_000;

export default class MetricsAnonymUserBehaviourImitation {

    rejectImitationTimer: number | null = null;
    goodVisitImitationTimer: number | null = null;

    activate(el: HTMLElement): void {

        const rejectImitationDuration = el.dataset.rejectImitationDuration ? Number(el.dataset.rejectImitationDuration) : DEFAULT_REJECT_DURATION;
        const goodVisitImitationDuration = el.dataset.visitImitationDuration ? Number(el.dataset.visitImitationDuration) : DEFAULT_VISIT_DURATION;
        const goalParamsMap = parseJsonConf(el, 'data-goal-params-map');

        const defaultParamsToSend = [null, true, {
            isPaidTraffic: goalParamsMap?.isPaidTraffic
        }] as Params[];

        yandexMetricService.trackGoal(Events.PAGE_INIT, ...defaultParamsToSend);
        myTrackerService.trackGoal(Events.PAGE_INIT, ...defaultParamsToSend);

        this.rejectImitationTimer = setTimeout(() => {
            yandexMetricService.trackGoal(Events.REJECT_IMITATION, ...defaultParamsToSend);
            myTrackerService.trackGoal(Events.REJECT_IMITATION, ...defaultParamsToSend);
        }, rejectImitationDuration);

        this.goodVisitImitationTimer = setTimeout(() => {
            yandexMetricService.trackGoal(Events.GOOD_VISIT_IMITATION, ...defaultParamsToSend);
            myTrackerService.trackGoal(Events.GOOD_VISIT_IMITATION, ...defaultParamsToSend);
        }, goodVisitImitationDuration);
    }

    deactivate() {
        clearTimeout(this.rejectImitationTimer!);
        clearTimeout(this.goodVisitImitationTimer!);

        this.rejectImitationTimer = null;
        this.goodVisitImitationTimer = null;
    }
}
